import React from "react";
import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav } from "reactstrap";
import "./style.css";
import Logo from "../../Images/logo.png";
import {
  LoginOutlined,
  LogoutOutlined,
  WarningTwoTone,
} from "@ant-design/icons";
import { Link } from "react-router-dom";
import { notification } from "antd";
import { Vendors } from "../../pages/vendors";

// function IndexNavbar() {
//   const [navbarColor, setNavbarColor] = React.useState("navbar-transparent");
//   const [navbarCollapse, setNavbarCollapse] = React.useState(false);

//   const toggleNavbarCollapse = () => {
//     setNavbarCollapse(!navbarCollapse);
//     document.documentElement.classList.toggle("nav-open");
//   };

//   React.useEffect(() => {
//     const updateNavbarColor = () => {
//       if (
//         document.documentElement.scrollTop > 299 ||
//         document.body.scrollTop > 299
//       ) {
//         setNavbarColor("");
//       } else if (
//         document.documentElement.scrollTop < 300 ||
//         document.body.scrollTop < 300
//       ) {
//         setNavbarColor("navbar-transparent");
//       }
//     };

//     window.addEventListener("scroll", updateNavbarColor);

//     return function cleanup() {
//       window.removeEventListener("scroll", updateNavbarColor);
//     };
//   });

class NavBar extends React.Component {
  constructor(props) {
    super(props);
    // console.log(props);

    this.state = {
      isOpen: false,
    };
  }

  toggle = () => {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  };

  render() {
    const {
      isSignedIn,
      // currentApplicant
    } = this.props;

    const notActiveNotification = () => {
      let placement = "bottomRight";
      const key = `open${Date.now()}`;
      notification.open({
        duration: 5,
        message: "Attention Champion!",
        description: (
          <div id="loading">
            <h3>Under Development.</h3>
            <p>Please visit again later, Thanks.</p>
          </div>
        ),
        placement,
        icon: <WarningTwoTone twoToneColor="#BF2F2F" />,
        key,
      });
    };

    return (
      <div className="navContainer">
        <Navbar
          className="homeNavBar animate__animated animate__fadeInDown"
          expand="md"
          dark
          fixed="top"
        >
          <NavbarBrand target="_blank" href="http://w4work.com/">
            <img src={Logo} alt="Logo" className="Logo" />
          </NavbarBrand>
          <NavbarToggler onClick={this.toggle} />
          <Collapse isOpen={this.state.isOpen} navbar>
            <Link to={"/"}>
              <strong className="Navheader">WORK</strong>
            </Link>
            <Nav className="mr-auto" navbar></Nav>

            {/* <span>Sign in &nbsp;&nbsp;</span> */}
            <Link to={"/"}>
              <span className="white navBarText">Home &nbsp;&nbsp;</span>
            </Link>

            <Link to={"/vendors"}>
              <span className="white navBarText">Vendors &nbsp;&nbsp;</span>
            </Link>

            <Link to={"/careers"}>
              <span className="white navBarText">Careers &nbsp;&nbsp;</span>
            </Link>

            {isSignedIn === false ? (
              <div>
                <span className="white">Login &nbsp;&nbsp;</span>
                <Link to={"/login"}>
                  <LoginOutlined
                    className="navBarText"
                    alt="Login"
                    title="Login"
                    style={{ fontSize: "25px" }}
                  />
                </Link>
              </div>
            ) : (
              <div>
                <span className="white">
                  {"Welcome, " + this.props.currentApplicant.name}&nbsp; &nbsp;
                </span>
                <Link to={"/"}>
                  <LogoutOutlined
                    className="navBarText"
                    alt="Logout"
                    title="Logout"
                    style={{ fontSize: "25px" }}
                    onClick={() => {
                      localStorage.removeItem("userData");
                      this.props.logoutSession();
                    }}
                  />
                </Link>
              </div>
            )}
          </Collapse>
        </Navbar>
      </div>
    );
  }
}

export default NavBar;
